import styled from "styled-components";
import colors from "@styling/colors";
import { fontSizes } from "@styling/fonts";

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: ${fontSizes.large}px;
  font-weight: 600;
  color: ${colors.text};
`;
